module.exports = __webpack_public_path__ + "static/img/coupon.40676554.png";